// assets/c_cpb-cart-qty.js (モーダル制御 + メッセージ表示 完全版)
(() => {
    const MAX_PER_PRODUCT = 5; // 商品ごとの上限数
    const SECTIONS_TO_UPDATE = ['cart-icon-bubble', 'cart-drawer', 'cart-drawer-items']; // カート更新時に再描画するセクションID

    // ---- ヘルパー関数 ----

    /**
     * 最新のカート情報を取得 (キャッシュ無効化 & エラーハンドリング強化版)
     * @returns {Promise<object>} カート情報オブジェクト (常に { items: [...] } 形式)
     */
    const getCart = () => {
        // console.log('[数量制限] キャッシュ無効でカート情報を取得中...'); // デバッグ用
        return fetch('/cart.js', {
            method: 'GET',
            headers: { 'Content-Type': 'application/json', 'Cache-Control': 'no-cache, no-store, must-revalidate', 'Pragma': 'no-cache', 'Expires': '0' },
            credentials: 'same-origin'
        })
        .then(response => {
            if (!response.ok) { console.warn(`[数量制限] カート情報取得失敗 (ステータス: ${response.status})。空のカートとして処理します。`); return { items: [] }; }
            return response.json().catch(jsonError => { console.error('[数量制限] カート情報のJSON解析に失敗:', jsonError); return { items: [] }; });
        })
        .then(cartData => {
             if (cartData && Array.isArray(cartData.items)) { /* console.log('[数量制限] カート情報取得成功'); */ return cartData; } // デバッグ用
             else { console.warn('[数量制限] 取得したカートデータの形式が不正です。', cartData); return { items: [] }; }
        })
        .catch(fetchError => { console.error('[数量制限] カート情報のfetch自体に失敗:', fetchError); return { items: [] }; });
    };

    /**
     * カートに商品を追加するAPI
     */
    const addToCart = (variantId, qty) => {
        // console.log(`[数量制限] API呼び出し: addToCart - variantId: ${variantId}, qty: ${qty}`); // デバッグ用
        return fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            credentials: 'same-origin',
            body: JSON.stringify({ id: Number(variantId), quantity: Number(qty) })
        }).then(r => r.json()).catch(e => console.error('[数量制限] addToCart API呼び出し失敗:', e));
    };

    /**
     * カート内商品の数量変更API
     */
    const changeLineQty = (line, qty) => {
        // console.log(`[数量制限] API呼び出し: changeLineQty - line: ${line}, qty: ${qty}`); // デバッグ用
        return fetch('/cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            credentials: 'same-origin',
            body: JSON.stringify({ line: Number(line), quantity: Number(qty) })
        }).then(r => r.json()).catch(e => console.error('[数量制限] changeLineQty API呼び出し失敗:', e));
    };

    /**
     * カート関連セクションの更新
     */
    const updateCartSections = async () => {
        // console.log('[数量制限] カートセクションを更新中...'); // デバッグ用
        try {
            const params = new URLSearchParams();
            params.set('sections', SECTIONS_TO_UPDATE.join(','));
            const res = await fetch(`/?${params.toString()}`, { credentials: 'same-origin' });
            if (!res.ok) throw new Error(`セクション取得失敗: ${res.statusText}`);
            const html = await res.json();
            if (html && typeof html === 'object') {
                SECTIONS_TO_UPDATE.forEach(id => {
                    const container = document.getElementById(`shopify-section-${id}`) || document.getElementById(id);
                    if (container && html[id]) container.innerHTML = html[id];
                    // else console.warn(`[数量制限] セクション ${id} のコンテナまたは内容が見つかりません。`); // デバッグ用
                });
            } else { console.warn('[数量制限] 不正なセクション応答形式です。'); }
        } catch (e) { console.error('[数量制限] updateCartSectionsでエラー:', e); }
    };

    /**
     * 個数制限モーダルの準備と表示
     */
    const ensureModal = () => {
        let modal = document.getElementById('qty-limit-modal');
        if (modal && modal._initialized) return modal;
        if (!modal) {
            modal = document.createElement('div');
            modal.id = 'qty-limit-modal';
            modal.innerHTML = `
            <div class="qty-limit-backdrop" style="position:fixed;inset:0;background:rgba(0,0,0,.4);display:flex;align-items:center;justify-content:center;z-index:99999;opacity:0;pointer-events:none;transition:opacity .2s ease;">
              <div class="qty-limit-dialog" role="dialog" aria-modal="true" style="max-width:520px;width:92%;background:#fff;padding:20px;border: 2px solid #000;text-align: center;">
                <h2 style="margin:10px 0;font-size:20px;font-weight: 400;">ご案内</h2>
                <p style="margin:0 0 16px;line-height:2.5;font-size: 12px;">
                  申し訳ございませんが、1日にご構入できる数量は<br>1品5個までとさせていただいています。
                </p>
                <div style="display:flex;gap:8px;justify-content:flex-end;">
                  <button type="button" class="qty-limit-close" style="border:1px solid #ddd;background-color: #d1d5db;padding:10px 14px;cursor:pointer;width: 100%;display: grid;place-items: center; max-width: 50%; margin: 0 auto;">閉じる</button>
                  <a href="/cart" class="qty-limit-gocart" style="border:none;background:#111;color:#fff;padding:10px 14px;cursor:pointer;text-decoration:none;width: 100%;background-color: #1e293b;display: grid;place-items: center;">カートを見る</a>
                </div>
              </div>
            </div>`;
            document.body.appendChild(modal);
        }
        const backdrop = modal.querySelector('.qty-limit-backdrop');
        const closeBtn = modal.querySelector('.qty-limit-close');
        const closeFunc = () => { backdrop.style.opacity = '0'; backdrop.style.pointerEvents = 'none'; };
        closeBtn.removeEventListener('click', closeFunc);
        closeBtn.addEventListener('click', closeFunc);
        modal._initialized = true;
        modal.show = () => { backdrop.style.opacity = '1'; backdrop.style.pointerEvents = 'auto'; console.log('[数量制限] 個数制限モーダルを表示します。'); };
        return modal;
    };

    /**
     * カート内数量を上限値に強制修正
     */
    const clampSameProductToFive = async (targetProductId, cartSnapshot = null) => {
        // console.log(`[数量制限] 商品 ${targetProductId} の数量をクランプ中...`); // デバッグ用
        try {
            const cart = cartSnapshot || await getCart();
            const linesToAdjust = [];
            let totalQuantity = 0;
            cart.items.forEach((item, idx) => { if (item.product_id === Number(targetProductId)) { totalQuantity += item.quantity; linesToAdjust.push({ line: idx + 1, qty: item.quantity }); } });
            // console.log(`[数量制限] クランプチェック - 合計: ${totalQuantity}, 上限: ${MAX_PER_PRODUCT}`); // デバッグ用
            if (totalQuantity <= MAX_PER_PRODUCT) { /* console.log(`[数量制限] クランプ不要。`); */ return; } // デバッグ用
            let quantityToRemove = totalQuantity - MAX_PER_PRODUCT;
            // console.log(`[数量制限] ${quantityToRemove} 個削減する必要があります。`); // デバッグ用
            for (let i = linesToAdjust.length - 1; i >= 0 && quantityToRemove > 0; i--) {
                const line = linesToAdjust[i];
                const amountToRemoveFromThisLine = Math.min(line.qty, quantityToRemove);
                if (amountToRemoveFromThisLine > 0) {
                    const newQuantity = line.qty - amountToRemoveFromThisLine;
                    // console.log(`[数量制限] 行 ${line.line} の数量を ${line.qty} から ${newQuantity} に削減。`); // デバッグ用
                    await changeLineQty(line.line, newQuantity);
                    quantityToRemove -= amountToRemoveFromThisLine;
                }
            }
             // console.log(`[数量制限] クランプ完了。`); // デバッグ用
        } catch (e) { console.error('[数量制限] clampSameProductToFiveでエラー:', e); }
    };

    /**
     * <product-info> 要素の取得
     */
    const getProductRoot = (el) => el.closest('product-info');

    /**
     * 商品IDの取得
     */
    const parseCurrentProductId = (formRoot) => formRoot?.dataset.productId || null;

    /**
     * 選択数量の取得
     */
    const getDesiredQtyFromForm = (formRoot) => {
        const i = formRoot?.querySelector('input[name="quantity"]');
        const v = Number(i?.value || 1);
        return Number.isFinite(v) && v > 0 ? v : 1;
    };

    /**
     * バリアントIDの取得
     */
    const getVariantIdFromForm = (formRoot) => {
        if (!formRoot) return null;
        const checked = formRoot.querySelector('input[name="id"]:checked'); if (checked) return checked.value;
        const select = formRoot.querySelector('select[name="id"]'); if (select) return select.value;
        const hidden = formRoot.querySelector('input[name="id"]'); if (hidden) return hidden.value;
        if (formRoot.dataset.currentVariant) return formRoot.dataset.currentVariant;
        console.warn('[数量制限] バリアントIDの特定に失敗。'); return null;
    };

    /**
     * 商品ページの数量制限メッセージ表示/非表示
     */
    const updateQuantityLimitMessageVisibility = (formRoot, projectedQty) => {
        const logPrefixMsg = '[数量制限 メッセージ]';
        // console.log(`${logPrefixMsg} 更新処理開始。予測合計: ${projectedQty}`); // デバッグ用
        if (!formRoot) { console.error(`${logPrefixMsg} エラー: 親要素が見つかりません。`); return; }
        const sectionId = formRoot.dataset.section;
        if (!sectionId) { console.error(`${logPrefixMsg} エラー: Section IDが取得できません。`); return; }
        const messageElementId = `QuantityLimitMessage-${sectionId}`;
        const messageElement = document.getElementById(messageElementId);
        if (!messageElement) { console.error(`${logPrefixMsg} ★★★ エラー: メッセージ要素 #${messageElementId} が見つかりません！`); return; }

        if (projectedQty >= MAX_PER_PRODUCT) { // 5個以上
            // console.log(`${logPrefixMsg} 判定: 5個以上 (${projectedQty}) -> 表示します。`); // デバッグ用
            messageElement.style.display = 'block';
        } else { // 4個以下
            // console.log(`${logPrefixMsg} 判定: 5個未満 (${projectedQty}) -> 非表示にします。`); // デバッグ用
            messageElement.style.display = 'none';
        }
        // console.log(`${logPrefixMsg} 更新処理終了。`); // デバッグ用
    };


    // ---- メインのロジック関数 ----
    const executeQtyLimitLogic = async (formRoot, evt, isClickEvent = false) => {
        const logPrefix = '[数量制限 ロジック]';
        // console.log(`${logPrefix} 実行開始。 isClick: ${isClickEvent}`); // デバッグ用
        let stopEvent = false;
        try {
            const productId = parseCurrentProductId(formRoot);
            const variantId = getVariantIdFromForm(formRoot);
            const desiredQty = getDesiredQtyFromForm(formRoot);
            // console.log(`${logPrefix} ID取得 - Product: ${productId}, Variant: ${variantId}, Qty選択: ${desiredQty}`); // デバッグ用
            if (!productId || !variantId) { console.warn(`${logPrefix} IDが見つかりません。イベントを許可します。`); return true; }

            const cart = await getCart();
            let currentSameProductQty = 0;
            cart.items.forEach(item => { if (item.product_id === Number(productId)) currentSameProductQty += item.quantity; });
            // console.log(`${logPrefix} カート内数量 (商品 ${productId}): ${currentSameProductQty}`); // デバッグ用

            const projectedQuantity = currentSameProductQty + desiredQty;
            const limitExceeded = projectedQuantity > MAX_PER_PRODUCT;
            console.log(`${logPrefix} 判定チェック - 予測合計:${projectedQuantity}, 上限:${MAX_PER_PRODUCT}, 超過:${limitExceeded}`);

            updateQuantityLimitMessageVisibility(formRoot, projectedQuantity); // メッセージ更新

            if (!limitExceeded) { // 制限内
                // console.log(`${logPrefix} 判定: 制限内。`); // デバッグ用
                if (isClickEvent) {
                    stopEvent = true;
                    // console.log(`${logPrefix} カウンセリングモーダルを手動で開きます。`); // デバッグ用
                    const counselingDialog = document.getElementById('s-dialog');
                    if (counselingDialog) counselingDialog.showModal(); else console.error(`${logPrefix} カウンセリングモーダル #s-dialog が見つかりません！`);
                } else return true; // Submit許可
            } else { // 制限超過
                stopEvent = true;
                // console.log(`${logPrefix} 判定: 制限超過。処理を実行します...`); // デバッグ用
                if (evt) { evt.preventDefault(); evt.stopImmediatePropagation(); /* console.log(`${logPrefix} イベント ${evt.type} を停止しました。`); */ } // デバッグ用
                // console.log(`${logPrefix} カート数量クランプと制限モーダル表示を実行...`); // デバッグ用
                await clampSameProductToFive(productId);
                await updateCartSections();
                ensureModal().show(); // 個数制限モーダル表示
            }
        } catch (e) { console.error(`${logPrefix} ロジック実行中にエラー発生:`, e); stopEvent = true; if (evt) { evt.preventDefault(); evt.stopImmediatePropagation(); } }
        finally { return !stopEvent; }
    };

    // ---- イベント委任 ----
    const handleCartAction = async (evt) => {
        let formRoot = null, targetElement = null, isClick = false;
        if (evt.type === 'submit') { targetElement = evt.target.closest('form'); if (targetElement && targetElement.closest('product-info')) formRoot = getProductRoot(targetElement); }
        else if (evt.type === 'click') { targetElement = evt.target.closest('.s_open-dialog-button'); if (targetElement) { formRoot = getProductRoot(targetElement); isClick = true; } }
        if (!formRoot) return;
        await executeQtyLimitLogic(formRoot, evt, isClick);
    };

    const handleQuantityChange = async (evt) => {
         const inputElement = evt.target; const formRoot = getProductRoot(inputElement); if (!formRoot) return;
         const productId = parseCurrentProductId(formRoot); if (!productId) return;
         const selectedQty = Number(inputElement.value); if (!Number.isFinite(selectedQty) || selectedQty < 0) return;
         try {
             const cart = await getCart(); let currentQtyInCart = 0;
             cart.items.forEach(item => { if (item.product_id === Number(productId)) currentQtyInCart += item.quantity; });
             const projectedTotalQty = currentQtyInCart + selectedQty;
             // console.log(`[数量制限 数量変更] 判定: カート内=${currentQtyInCart}, 選択=${selectedQty}, 予測合計=${projectedTotalQty}`); // デバッグ用
             updateQuantityLimitMessageVisibility(formRoot, projectedTotalQty); // メッセージ更新
         } catch(e) { console.error('[数量制限 数量変更] エラー:', e); }
    };

    // ---- リスナー設定 ----
    document.addEventListener('submit', handleCartAction, { capture: true });
    document.addEventListener('click', handleCartAction, { capture: true });
    document.addEventListener('input', (evt) => { if (evt.target.matches('input[name="quantity"]') && getProductRoot(evt.target)) handleQuantityChange(evt); }, { capture: true });
    document.addEventListener('change', (evt) => { if (evt.target.matches('input[name="quantity"]') && getProductRoot(evt.target)) handleQuantityChange(evt); }, { capture: true });

    document.addEventListener('DOMContentLoaded', async () => {
        const logPrefixInit = '[数量制限 初期チェック]';
        // console.log(`${logPrefixInit} 開始。`); // デバッグ用
        const productInfoElement = document.querySelector('product-info[data-product-id]');
        if (!productInfoElement) { console.warn(`${logPrefixInit} <product-info> 要素が見つかりません。`); return; }
        const productId = parseCurrentProductId(productInfoElement); if(!productId) { console.warn(`${logPrefixInit} 初期商品IDが取得できません。`); return; }
        const selectedQty = getDesiredQtyFromForm(productInfoElement);
        try {
            const cart = await getCart(); let currentQty = 0;
            cart.items.forEach(item => { if (item.product_id === Number(productId)) currentQty += item.quantity; });
            const projectedQty = currentQty + selectedQty;
            // console.log(`${logPrefixInit} 判定: カート内=${currentQty}, 初期選択=${selectedQty}, 予測合計=${projectedQty}`); // デバッグ用
            updateQuantityLimitMessageVisibility(productInfoElement, projectedQty); // メッセージ更新
        } catch(e) { console.error(`${logPrefixInit} エラー:`, e); }
    });

    // 追加機能: カート画面（ドロワー含む）での数量変更監視 
    const TARGET_BRAND_NAME = "クレ・ド・ポー ボーテ";

    const isRestrictedBrand = (element) => {
        if (!element) return false;
        // 親要素を遡って data-brand-name を探す
        const container = element.closest('[data-brand-name]');
        if (!container) return false;
        
        const brand = container.dataset.brandName;
        // ブランド名が一致するか判定 (前後の空白削除して比較)
        return brand && brand.trim() === TARGET_BRAND_NAME;
    };

    const handleCartInputChange = async (evt) => {
        const target = evt.target;
        // カート入力欄の判定
        const isCartInput = target.matches('.quantity__input') || target.matches('[name="updates[]"]') || (target.id && target.id.includes('Quantity-'));
        const isInCartContainer = target.closest('cart-items') || target.closest('cart-drawer-items') || target.closest('.cart-drawer') || target.closest('form[action="/cart"]');
        
        if (!isCartInput || !isInCartContainer) return;
        
        // ブランドチェック
        if (!isRestrictedBrand(target)) return;

        const newQty = Number(target.value);
        if (!Number.isFinite(newQty) || newQty < 0) return;

        // 行番号特定
        const lineAttr = target.dataset.index; 
        
        try {
            // まず最新のカートを取得
            const cart = await getCart();
            let targetItem = null;
            let targetLineIndex = -1;

            if (lineAttr) {
                const idx = Number(lineAttr);
                if (cart.items[idx - 1]) { targetItem = cart.items[idx - 1]; targetLineIndex = idx; } 
                else if (cart.items[idx]) { targetItem = cart.items[idx]; targetLineIndex = idx + 1; } 
            }
            if (!targetItem) {
                const variantKey = target.closest('.cart-item')?.querySelector('[name*="id"]')?.value || target.dataset.key;
                if(variantKey) {
                    targetItem = cart.items.find(item => item.key === variantKey || String(item.variant_id) === String(variantKey));
                    if(targetItem) targetLineIndex = cart.items.indexOf(targetItem) + 1;
                }
            }

            if (!targetItem) return;

            const productId = targetItem.product_id;
            
            // カート内で「同じ商品ID」の数を合計
            let totalProductQty = 0;
            let otherLinesQty = 0;

            cart.items.forEach((item, i) => {
                if (item.product_id === productId) {
                    if ((i + 1) === targetLineIndex) {
                        totalProductQty += newQty; // 入力値
                    } else {
                        totalProductQty += item.quantity; // 他の行
                        otherLinesQty += item.quantity;
                    }
                }
            });

            // 上限チェック
            if (totalProductQty > MAX_PER_PRODUCT) {
                console.log(`[数量制限] 制限発動: ${totalProductQty}個 -> 強制修正`);

                evt.preventDefault();
                evt.stopPropagation();
                evt.stopImmediatePropagation();
                
                // 許容数算出
                const allowedQty = Math.max(0, MAX_PER_PRODUCT - otherLinesQty);
                
                // 1. 画面上の数値を即座に修正
                target.value = allowedQty;

                // エラーメッセージ非表示
                const errorText = target.closest('.cart-item')?.querySelector('.cart-item__error-text') || 
                                  target.closest('.cart-drawer-item')?.querySelector('.cart-item__error-text') ||
                                  target.parentElement.querySelector('.cart-item__error-text');
                if (errorText) {
                    errorText.style.display = 'none';
                    errorText.textContent = '';
                }

                // 2. APIで正しい値に確定
                await changeLineQty(targetLineIndex, allowedQty);
                await updateCartSections();
                
                // 3. モーダル表示
                const modal = ensureModal();
                const goCartBtn = modal.querySelector('.qty-limit-gocart');
                if (goCartBtn) {
                    goCartBtn.style.display = (window.location.pathname === '/cart') ? 'none' : 'grid';
                }
                modal.show();
            }

        } catch(e) {
            console.error('[数量制限] カート監視エラー:', e);
        }
    };

    // カート画面用のイベントリスナーを追加
    document.addEventListener('change', handleCartInputChange, { capture: true });

    console.log('[数量制限] スクリプト実行完了 (モーダル制御 + メッセージ表示 完全版)');

})();